import React, {Component} from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import NewSweetAlert from 'react-bootstrap-sweetalert';
import Loader from 'react-loader-advanced';
import Spinner from 'react-bootstrap/Spinner'
import * as actionTypes from '../../../Action/Index';
import { connect } from 'react-redux';
import './SweetAlert.css'

class Alert extends Component {
    state = {
        show: this.props.show,
        emailVerify:false,
    }
     closeBothModal=()=>{
      
        if(parseInt(this.props.ErrorCode)===151){
            this.setState({ emailVerify:true,show:false})
        }else{
            this.setState({show:false});
            this.props.closeModal();
        }
       
     }
     hideAlert=()=>{
         this.setState({ emailVerify:false})
         this.props.closeModal();
     }
    render(){
        return(
            <div>
        {  this.state.show ? <SweetAlert style = {{width: '400px', marginLeft: '-210px'}}
              type = {this.props.type}
              confirmBtnBsStyle = "none"
              confirmBtnCssClass = 'confirmButtonStyle'
              onConfirm={()=>this.closeBothModal()}
              focusConfirm={true}
              title=""
              >
                {this.props.msg}
                </SweetAlert> : null}
                {this.state.emailVerify===true? 
                    <NewSweetAlert style={{ width: '400px', marginLeft: '-210px' }}
                    success
                    onConfirm={this.hideAlert}
                    confirmBtnBsStyle = "none"
                    confirmBtnCssClass = 'confirmButtonStyle'>
                    {`We've sent an email to ${this.props.email}. Click the verification link in that email to activate your account.`}
                    <br /><br /><span>Didn't receive the email? </span><a href="javascript:void(0)" onClick={() => this.props.resendInterviewerEmail(this.props.email)}
                        style={{ color: '#fbb03b', fontWeight: "bold" }}>Resend</a>
                        {this.props.resendInterviewerEmailStatus ? <span><i class="fa fa-check" style={{ color: "#5cb85c", position: "absolute", left: "363px", bottom: "102px" }} aria-hidden="true"></i></span> : null}
                        {this.props.resendInterviewerEmailLoader ? <div style={{ margin: "-35px 0px 0px 337px" }}>
                        <Spinner animation="border" variant='warning' role="status">
                        </Spinner>
                    </div> : ""}
                </NewSweetAlert>:null}
                </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        resendInterviewerEmailStatus:state.employeeReducer.resendInterviewerEmailStatus,
        resendInterviewerEmailLoader:state.employeeReducer.resendInterviewerEmailLoader
    }
}

const mapDispatchToProps = dispatch => {
    return {
        clearLoginState:()=>dispatch(actionTypes.clearLoginState()),
        resendInterviewerEmail:(email)=>dispatch(actionTypes.resendInterviewerEmail(email))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Alert);
